import { useContext } from "react";
import context from "./context";

const useExportConfig = () => useContext(context);
export default useExportConfig;
